module.exports = __webpack_public_path__ + "static/media/ic_decline-letter.a214efa5.svg";